module.exports = __webpack_public_path__ + "img/addressIcon.489cb021.svg";